<div class="metric-cards" [ngClass]="layoutClass()" role="list">
  <div
    class="metric-cards__card"
    *ngFor="let item of items; trackBy: trackById"
    role="listitem"
  >
    <div
      class="metric-cards__interactive"
      [class.is-selected]="isSelected(item)"
      [attr.role]="selectable ? 'button' : null"
      [attr.tabindex]="selectable ? 0 : null"
      [attr.aria-pressed]="selectable ? isSelected(item) : null"
      (click)="onCardClick(item)"
      (keydown)="onCardKeydown($event, item)"
    >
      <div
        class="metric-cards__icon"
        [ngClass]="'metric-cards__icon--' + resolveTone(item.tone)"
      >
        <mat-icon class="material-symbols-rounded">{{ item.icon }}</mat-icon>
      </div>
      <div class="metric-cards__body">
        <p class="metric-cards__label">
          <span class="metric-cards__label-text">
            <ng-container *ngIf="item.labelKey; else plainLabel">
              {{ item.labelKey | translate }}
            </ng-container>
            <ng-template #plainLabel>{{ item.label }}</ng-template>
          </span>
          <common-tooltip
            *ngIf="item.tooltip || item.tooltipKey"
            class="metric-cards__tooltip"
            position="above"
            panelClass="munily-tooltip-panel--wide"
            [text]="item.tooltip ? item.tooltip : (item.tooltipKey | translate)"
            (click)="$event.stopPropagation()"
          ></common-tooltip>
        </p>
        <p class="metric-cards__value">{{ item.value }}</p>
        <p *ngIf="item.subValue" class="metric-cards__meta">
          <span>{{ item.subValue }}</span>
        </p>
        <p *ngIf="showDelta(item)" class="metric-cards__meta metric-cards__meta--delta">
          <mat-icon class="material-symbols-rounded metric-cards__delta-icon" aria-hidden="true">
            arrow_upward
          </mat-icon>
          <span>{{ item.deltaPercent | number: '1.1-1' }}%</span>
        </p>
      </div>
    </div>
  </div>
</div>
